module.exports = __webpack_public_path__ + "img/123.4ffa4ef0.jpg";